import { seoOgDescription } from './SeoStore';

export const updateSeoOgDescription = (value) => seoOgDescription.update(oldValue => value);
